module.exports = __webpack_public_path__ + "static/img/11.d2e5fbb5.jpeg";